const compareObjects = <T extends object>(obj1: T, obj2: T): boolean => {
    const keys = Object.keys(obj1) as (keyof T)[];
    return keys.every(key => obj1[key] === obj2[key]);
  };
  
export default function hasValueChanged<T extends object>(table1: T[], table2: T[]): boolean  {
    if (table1.length !== table2.length) {
      return true;
    }
    return !table1.every((obj1, index) => compareObjects(obj1, table2[index]));
  }